/*
 * Default values for the widget's numeric configuration attributes. These are the single
 * source of truth used both for `withDefaults` (missing attribute) and for the empty-string
 * fallback (attribute present but blank, e.g. min-budget-amount=""), since custom-element
 * attributes always arrive as strings and an empty string is not treated as missing.
 */
export const WIDGET_NUMERIC_DEFAULTS = {
    minGuestAmount: 0,
    maxGuestAmount: 1000,
    guestAmountStep: 1,
    minBudgetAmount: 0,
    maxBudgetAmount: 25000,
    budgetStep: 100,
} as const;
